module.exports = __webpack_public_path__ + "img/4.a21f2bb3.png";